<span class="dynamic-content" *ngIf="htmlContent" [innerHTML]="htmlContent" (ngInit)="afterInit()" [isLast]='true'>
</span>